import { render, staticRenderFns } from "./edit-company.component.html?vue&type=template&id=4c13f17f&scoped=true&external"
import script from "./edit-company.component.ts?vue&type=script&lang=ts&external"
export * from "./edit-company.component.ts?vue&type=script&lang=ts&external"
import style0 from "./edit-company.component.scss?vue&type=style&index=0&id=4c13f17f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c13f17f",
  null
  
)

export default component.exports